<template>
  <div class="data-grid-row-preview">
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span v-if="gridData.currentRow">第<span class="row">{{currentIndex + 1}}</span>行数据</span>
        <span v-else>请选择</span>
        <el-button type="text" class="btn-hide-preview" @click="hideCompositeLayout"><i class="iconfont icon-cancel"></i></el-button>
      </div>
      <div class="main">
        <AppScrollbar style="height: 100%" v-if="gridData.currentRow">
          <div class="row-data-container">
            <table class="row-data-preview">
              <tr v-for="(column, index) in gridListableColumns"
                  :key="'row-data-preview-' + index">
                <td class="data-label">{{column.name}}</td>
                <td class="data-value" v-if="column.renderAction">
                  <CompositeTableActionCell :table-column="column"
                                            :row-index="currentIndex"
                                            :row-data="gridData.currentRow"
                                            v-bind="$attrs"
                                            v-on="$listeners">
                  </CompositeTableActionCell>
                </td>
                <td class="data-value" v-else v-html="rowPropValue(column.prop)"></td>
              </tr>
            </table>
          </div>
        </AppScrollbar>
        <Hint v-else>
          请选择要查看的数据
        </Hint>
      </div>
    </el-card>
  </div>
</template>

<script>
import AppScrollbar from '../../elements/AppScrollbar'
import Hint from '../../elements/Hint'
import CompositeTableActionCell from '../../elements/grid/CompositeTableActionCell'
import { getValueByPath } from 'element-ui/lib/utils/util'
export default {
  name: 'DataGridRowPreview',
  components: {AppScrollbar, Hint, CompositeTableActionCell},
  props: {
    gridData: {
      required: true,
      type: Object
    }
  },
  computed: {
    currentIndex: function () {
      let currentRow = this.gridData.currentRow
      if (currentRow) {
        let rowList = this.gridData.rowList
        if (rowList) {
          return rowList.findIndex((data) => {
            return data === currentRow
          })
        }
      }
      return -1
    },
    gridListableColumns: function () {
      let columns = this.gridData.config ? this.gridData.config.columns : null
      if (columns) {
        let listableColumns = []
        columns.forEach((column, index) => {
          // 如果是复合结构不考虑子列
          if (!column['childColumns'] && column['isListable']) {
            listableColumns.push(column)
          }
        })
        return listableColumns
      } else {
        return null
      }
    }
  },
  methods: {
    rowPropValue (prop) {
      let currentRow = this.gridData.currentRow
      if (currentRow) {
        return getValueByPath(currentRow, prop)
      } else {
        return null
      }
    },
    showCompositeLayout: function () {
      this.$emit('showCompositeLayout')
    },
    hideCompositeLayout: function () {
      this.$emit('hideCompositeLayout')
      this.$emit('clearGridCurrentRow')
    }
  },
  watch: {
    'gridData.currentRow': function (newVal, oldVal) {
      if (newVal) {
        this.showCompositeLayout()
      } else {
        if (oldVal) {
          this.hideCompositeLayout()
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @use "../../../styles/color" as *;

  .data-grid-row-preview {
    position: relative;
    height: 100%;
    background-color: #fff;
    & > .el-card {
      border: none;
      border-radius: 0;
      & > .el-card__header {
        position: relative;
        height: 40px;
        padding: 0 15px;
        font-size: 13px;
        text-align: center;
        line-height: 40px;
        .btn-hide-preview {
          position: absolute;
          right: 5px;
          top: 50%;
          color: #606266;
          transform: translateY(-50%) scale(.9);
          &:hover {
            color: #303133;
          }
        }
      }
      & > .el-card__body {
        position: absolute;
        left: 0;
        top: 40px;
        width: 100%;
        bottom: 0;
        padding: 0;
        .main {
          height: 100%;
          .row-data-container {
            padding: 5px 10px;
            box-sizing: border-box;
            & > .row-data-preview {
              width: 100%;
              font-size: 12px;
              border-collapse: collapse;
              table-layout: fixed;
              tr {
                &:last-child {
                  td {
                    border-bottom: none;
                  }
                }
                td {
                  padding: 5px 10px;
                  line-height: 24px;
                  border-right: 1px solid #ebeef5;
                  border-bottom: 1px solid rgba(0,0,0,.02);
                  &:last-child {
                    border-right: none;
                  }
                  &.data-label {
                    width: 30%;
                    color: #303133;
                    font-weight: bold;
                    white-space: nowrap;
                    vertical-align: top;
                  }
                  &.data-value {
                    color: #303133;
                    word-wrap: break-word;
                    word-break: break-all;
                    .el-tag {
                      & + .el-tag {
                        margin-left: 8px;
                      }
                      &.el-tag--default {
                        @extend .color-default, .border-style;
                      }
                      &.el-tag--primary {
                        @extend .color-primary, .border-style;
                      }
                      &.el-tag--success {
                        @extend .color-success, .border-style;
                      }
                      &.el-tag--info {
                        @extend .color-info, .border-style;
                      }
                      &.el-tag--warning {
                        @extend .color-warning, .border-style;
                      }
                      &.el-tag--danger {
                        @extend .color-danger, .border-style;
                      }
                    }
                    .el-switch {
                      top: -1px;
                      transform: scale(.8);
                      &.is-disabled {
                        .el-switch__core {
                          cursor: default!important;
                        }
                      }
                    }
                    .el-rate {
                      position: relative;
                      top: 1px;
                      .el-rate__text {
                        font-size: 12px;
                      }
                    }
                    .el-progress {
                      &.el-progress--line {
                        .el-progress-bar__inner {
                          & > .el-progress-bar__innerText {
                            display: block;
                            line-height: 12px;
                            transform: scale(.9) translate(5%, -5%);
                          }
                        }
                      }
                      &.el-progress--circle {
                        top: 3px;
                        .el-progress__text {
                          font-size: 12px!important;
                          transform: scale(.9) translate(0,-50%);
                        }
                      }
                      &.progress-bar-default {
                        .el-progress-bar__inner {
                          background-color: $set-default-color;
                        }
                        path:nth-child(2) {
                          stroke: $set-default-color;
                        }
                      }
                      &.progress-bar-primary {
                        .el-progress-bar__inner {
                          background-color: $set-primary-color;
                        }
                        path:nth-child(2) {
                          stroke: $set-primary-color;
                        }
                      }
                      &.progress-bar-success {
                        .el-progress-bar__inner {
                          background-color: $set-success-color;
                        }
                        path:nth-child(2) {
                          stroke: $set-success-color;
                        }
                      }
                      &.progress-bar-info {
                        .el-progress-bar__inner {
                          background-color: $set-info-color;
                        }
                        path:nth-child(2) {
                          stroke: $set-info-color;
                        }
                      }
                      &.progress-bar-warning {
                        .el-progress-bar__inner {
                          background-color: $set-warning-color;
                        }
                        path:nth-child(2) {
                          stroke: $set-warning-color;
                        }
                      }
                      &.progress-bar-danger {
                        .el-progress-bar__inner {
                          background-color: $set-danger-color;
                        }
                        path:nth-child(2) {
                          stroke: $set-danger-color;
                        }
                      }
                    }
                    .data-table-cell {
                      a,
                      button {
                        position: relative;
                        padding: 0;
                        &.action-cell {
                          display: inline-block;
                          text-decoration: none;
                          cursor: pointer;
                          &:hover {
                            transform: translateY(1px);
                          }
                          i {
                            vertical-align: -1px;
                          }
                        }
                      }
                    }
                    .data-table-cell-default {
                      color: $set-default-color;
                      a,
                      button {
                        color: $set-default-color;
                      }
                    }
                    .data-table-cell-primary {
                      color: $set-primary-color;
                      a,
                      button {
                        color: $set-primary-color;
                      }
                    }
                    .data-table-cell-success {
                      color: $set-success-color;
                      a,
                      button {
                        color: $set-success-color;
                      }
                    }
                    .data-table-cell-info {
                      color: $set-info-color;
                      a,
                      button {
                        color: $set-info-color;
                      }
                    }
                    .data-table-cell-warning {
                      color: $set-warning-color;
                      a,
                      button {
                        color: $set-warning-color;
                      }
                    }
                    .data-table-cell-danger {
                      color: $set-danger-color;
                      a,
                      button {
                        color: $set-danger-color;
                      }
                    }
                    .data-table-cell-empty {
                      color: $set-empty-color;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
